import styled from 'styled-components';

import { FactHeading, FactSubHeading } from '~/components/Elements';
import { colors, spacing, stickyStyles } from '~/utils/css-mixins';
import media from '~/utils/media';

export { FactSubHeading as HeadlineSub } from '~/components/Elements';

export const Headline = styled(FactHeading)`
  margin-top: ${spacing.siteGutter * 2}px;
  margin-bottom: 8px;
`;

export const Intro = styled.div`
  margin-bottom: 10px;
  max-width: ${spacing.siteContentWidth};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.text};
`;

export const Disclaimer = styled.div`
  margin-top: 5px;
  max-width: ${spacing.siteContentWidth};
  color: ${colors.textmeta};
  font-size: 14px;
  font-style: italic;
  line-height: 20px;
`;

export const Menu = styled.div`
  border-left: solid 1px ${colors.primary};
  padding-top: 0;
  padding-left: ${spacing.siteGutter}px;
  display: none;
  ${stickyStyles(75)}
  color: ${colors.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;

  a {
    display: block;
    color: inherit;
  }

  a:hover {
    cursor: pointer;
  }

  .active {
    color: ${colors.link};

    &::before {
      content: '';
      height: 40px;
      width: 3px;
      position: absolute;
      left: -2px;
      display: inline-block;
      background-color: ${colors.primary};
      border-radius: 2px;
      margin-top: -6px;
    }
  }

  ${media.tablet`
    display: block;
  `}
`;

export const Label = styled.div`
  margin-bottom: 8px;
  text-transform: uppercase;
`;

export const TableSideValue = styled.span`
  margin-left: 0.5em;
  color: ${colors.textmeta};

  &::before {
    content: '(';
  }

  &::after {
    content: ')';
  }
`;

const Fact = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
`;

const FactItemsRow = styled.div`
  margin: 5px 0;

  > span {
    margin-left: 0.25em;
    color: ${colors.textmeta};
  }
`;

export const FactElement = ({ items = [], ...rest }) => (
  <Fact {...rest}>
    {items.map(({ label, value, mean }) => (
      <FactItemsRow key={label} className="fact-row">
        {label}: <strong>{value}</strong>
        {mean && <span>({mean})</span>}
      </FactItemsRow>
    ))}
  </Fact>
);

export const FactSpecial = ({ stats }) => (
  <div>
    <FactSubHeading>{stats.headline}</FactSubHeading>

    <Intro>
      <strong>{stats.value}%</strong> - {stats.intro}
    </Intro>
  </div>
);
